export interface ReorderableHeader {
  id: string;
  label: string;
}

export const orderHeaders = <THeader extends ReorderableHeader>(
  headers: THeader[],
  orderedHeaderIds: string[] | undefined,
): THeader[] => {
  if (!orderedHeaderIds?.length) {
    return headers;
  }
  const ordered = orderedHeaderIds
    .map((orderedId) => headers.find((header) => header.id === orderedId))
    .filter((header): header is THeader => header !== undefined);
  const unordered = headers.filter((header) => !orderedHeaderIds.includes(header.id));
  return [...ordered, ...unordered];
};

export const hasOrderChanged = <THeader extends ReorderableHeader>(
  currentHeaders: THeader[],
  originalHeaders: THeader[],
): boolean =>
  currentHeaders.length !== originalHeaders.length ||
  currentHeaders.some((header, index) => header.id !== originalHeaders[index]?.id);
